import { Slate } from "@makeswift/controls";
const ElementUtils = {
  createText() {
    return { text: "" };
  },
  createParagraph() {
    return {
      children: [this.createText()],
      type: Slate.BlockType.Paragraph
    };
  },
  createList(type = Slate.BlockType.UnorderedList) {
    return { children: [this.createText()], type };
  },
  createListItem() {
    return {
      children: [this.createListItemChild()],
      type: Slate.BlockType.ListItem
    };
  },
  createListItemChild() {
    return {
      children: [this.createText()],
      type: Slate.BlockType.ListItemChild
    };
  }
};
export {
  ElementUtils
};
//# sourceMappingURL=element.js.map